import type { Provider } from "../providers/provider";
import type { DailySchedule } from "./daily-schedule";
import { getDailySchedulesForWeekdayAndProvider } from "./get-daily-schedules-for-weekday-and-provider";

const getTodaysDailyScheduleForProvider = (
    provider: Provider,
): DailySchedule[] =>
    getDailySchedulesForWeekdayAndProvider(new Date(), provider);

export { getTodaysDailyScheduleForProvider };
